// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._9L0KlHO1a8DaIfbOcQTQ{container-type:inline-size}.up9EqWWSYO8r1koJFNin{position:relative}", "",{"version":3,"sources":["webpack://./src/common/components/layout/TemplateViewport.module.scss"],"names":[],"mappings":"AAAA,uBACE,0BAAA,CAGF,sBACE,iBAAA","sourcesContent":[".viewport {\n  container-type: inline-size;\n}\n\n.relative {\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewport": "_9L0KlHO1a8DaIfbOcQTQ",
	"relative": "up9EqWWSYO8r1koJFNin"
};
export default ___CSS_LOADER_EXPORT___;
